<template>
  <v-container fluid class="pa-6">
    <!-- Profile Header -->
    <v-row class="mb-6">
      <v-col cols="12">
        <v-card flat>
          <v-card-text class="d-flex align-center pa-0">
            <v-avatar size="64" class="me-4">
              <v-img :src="avatarUrl" alt="Profile"></v-img>
            </v-avatar>
            <div>
              <div class="d-flex align-center">
                <h2 class="text-h5 me-2">{{ firstName }} {{ lastName }}</h2>
                <!-- <v-icon color="orange" size="small">mdi-star</v-icon> -->
              </div>
              <div class="text-body-2 text-medium-emphasis">
                <span class="me-4">{{ noOfClients }} {{ $t('psychologistDashboard.clients') }}</span>
                <!-- <span class="me-4">{{ profileData.sessions }} SESSIONS</span> -->
                <span class="me-4">{{ noOfEvaluations }} {{ $t('psychologistDashboard.questionnaires') }}</span>
                <!-- <span>{{ profileData.notes }} NOTES</span> -->
              </div>
            </div>
            <v-spacer></v-spacer>
            <div>
              <!-- <v-btn icon variant="text" color="blue">
                <v-icon>mdi-bookmark</v-icon>
              </v-btn>
              <v-btn icon variant="text" color="red">
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon variant="text">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn> -->
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Metrics Cards -->
    <v-row class="mb-6">
      <v-col cols="12" sm="6" lg="3" 
        v-for="metric in metrics" :key="metric.title"
        @click="$router.push(metric.link)"
        style="cursor: pointer;"
      >
        <v-card elevation="2" class="h-100 clickable-area">
          <v-card-text>
            <div class="d-flex justify-space-between align-start">
              <div>
                <div class="text-body-2 text-medium-emphasis mb-2">{{ metric.title }}</div>
                <div class="text-h4 font-weight-bold">{{ metric.value }}</div>
              </div>
              <v-avatar size="40" :color="metric.iconColor" variant="tonal">
                <v-icon :color="metric.iconColor">{{ metric.icon }}</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Content Row -->
    <v-row>
      <!-- Evaluations -->
      <v-col cols="12" lg="6">
        <v-card elevation="2" class="h-100" ripple>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>{{ $t('psychologistDashboard.last_evaluations') }}</span>
            <!-- <v-btn icon variant="text" size="small">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn> -->
          </v-card-title>
          <v-card-text class="pa-0">
            <div 
              v-for="evaluation in lastEvaluations" 
              :key="evaluation.id" 
              class="d-flex align-center pa-4 border-b clickable-area"
              :style="{ borderLeft: `4px solid ${getStatusColor(evaluation.status)}` }"
              @click="$router.push(`/psychologist/viewEvaluation/${evaluation.evaluationToken}`)" style="cursor: pointer;"
            >
              <div class="text-center me-4" style="min-width: 60px;">
                <div class="text-h5 font-weight-bold">{{ evaluation.day }}</div>
                <div class="text-caption text-uppercase">{{ evaluation.dayName }}</div>
              </div>
              <div class="flex-grow-1">
                <div class="text-body-2 text-medium-emphasis mb-1">{{ evaluation.time }}</div>
                <div class="text-body-1 font-weight-medium">{{ evaluation.title }}</div>
              </div>
              <div class="d-flex">
                <div class="d-flex me-2">
                  <v-chip
                    v-for="(scale, index) in evaluation.scales"
                    :key="index"
                    variant="outlined">
                    {{ scale }}                    
                  </v-chip>
                </div>
                <!-- <span class="text-body-2 text-medium-emphasis align-self-center">
                  {{ event.count }}
                </span> -->
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Upcoming Events -->
      <!-- <v-col cols="12" lg="6">
        <v-card elevation="2" class="h-100">
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Upcoming Events</span>
            <v-btn icon variant="text" size="small">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <div v-for="event in upcomingEvents" :key="event.id" class="d-flex align-center pa-4 border-b">
              <div class="text-center me-4" style="min-width: 60px;">
                <div class="text-h5 font-weight-bold">{{ event.day }}</div>
                <div class="text-caption text-uppercase">{{ event.dayName }}</div>
              </div>
              <div class="flex-grow-1">
                <div class="text-body-2 text-medium-emphasis mb-1">{{ event.time }}</div>
                <div class="text-body-1 font-weight-medium">{{ event.title }}</div>
              </div>
              <div class="d-flex">
                <div class="d-flex me-2">
                  <v-avatar
                    v-for="(avatar, index) in event.avatars"
                    :key="index"
                    size="32"
                  >
                    <v-img :src="avatar"></v-img>
                  </v-avatar>
                </div>
                <span class="text-body-2 text-medium-emphasis align-self-center">
                  {{ event.count }}
                </span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col> -->

      <!-- Next Meeting -->
      <!-- <v-col cols="12" lg="6">
        <v-card elevation="2" class="h-100">
          <v-card-title>Next Meeting</v-card-title>
          <v-card-text>
            <div class="text-body-2 text-medium-emphasis mb-4">
              You can manage this meeting from your calendar or the email confirmation sent to your inbox.
            </div>
            
            <div class="mb-4">
              <div class="d-flex align-center mb-3">
                <v-icon class="me-3" color="grey">mdi-calendar</v-icon>
                <span clIndividual Therapy Session - ass="text-body-1 font-weight-medium">{{ nextMeeting.title }}</span>
              </div>
              
              <div class="d-flex align-center mb-3">
                <v-icon class="me-3" color="grey">mdi-clock-outline</v-icon>
                <span class="text-body-1">{{ nextMeeting.dateTime }}</span>
              </div>
              
              <div class="d-flex align-center mb-3">
                <v-icon class="me-3" color="grey">mdi-earth</v-icon>
                <span class="text-body-1">{{ nextMeeting.timezone }}</span>
              </div>
              
              <div class="d-flex align-start">
                <v-icon class="me-3" color="grey">mdi-note-text</v-icon>
                <span class="text-body-1">{{ nextMeeting.notes }}</span>
              </div>
            </div>

            <div class="d-flex justify-end">
              <v-btn variant="outlined" size="small" class="me-2">
                <v-icon start>mdi-calendar-plus</v-icon>
                Add to Calendar
              </v-btn>
              <v-btn variant="outlined" size="small" class="me-2">
                <v-icon start>mdi-email</v-icon>
                Email
              </v-btn>
              <v-btn variant="outlined" size="small">
                <v-icon start>mdi-video</v-icon>
                Join
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import { appStore } from '@/stores/AppStore'
import apiService from '@/services/ApiService'
import {formatDate, formatTime, dayOfDate,dayNameOfDate} from '@/utils/time.js'

export default {
  name: 'DashboardContent',
  data() {
    return {
      loading: true,
      error: '',
      noOfEvaluations: 0,
      noOfClients: 0,
      evaluations: [],

      profileData: {
        name: 'Psih. Sarah Wilson',
        avatar: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=64&h=64&fit=crop&crop=face',
        clients: '45',
        sessions: '234',
        questionnaires: '67',
        notes: '890'
      },
      // nextMeeting: {
      //   title: 'Dr. Sarah Wilson - Session Review with Clinical Supervisor',
      //   dateTime: '10:35 AM - 10:50 AM Wednesday, September 25, 2024',
      //   timezone: '(UTC-06:00) Central Time (US & Canada)',
      //   notes: 'Monthly supervision meeting to discuss case progress and treatment plans.'
      // }
    }
  },

  async created(){
  },

  async mounted() {
    // this.store.initAuth();

    await this.loadEvaluationsNo();

    await this.loadClientsNo();

    await this.loadEvaluations();
  },

  methods: {

    async loadEvaluationsNo (){
      try{
        this.loading = true;
        let countResp = await apiService.getEvaluationsTotalNo();
        console.info(`Total no. of evaluations (raw) : ` + countResp);

        let count = countResp.count;
        console.info(`Total no. of evaluations : ` + count);

        this.noOfEvaluations = count;
      }catch(error){
        console.error('Error fetching data:', error);
      } finally{
        this.loading = false;
      }
    },

    async loadClientsNo (){
      try{
        this.loading = true;
        let countResp = await apiService.getClientsNo();
        console.info(`Total no. of clients (raw) : ` + countResp);

        let count = countResp.count;
        console.info(`Total no. of clients : ` + count);

        this.noOfClients = count;
      }catch(error){
        console.error('Error fetching data:', error);
      } finally{
        this.loading = false;
      }
    },

    async loadEvaluations(){
        try {
            this.loading = true
            let evaluations = await apiService.getEvaluations()
            console.log('Response:', evaluations);

            this.evaluations = evaluations.data;
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            this.loading = false;
        }
    },


    getStatusColor: (status) => {
      if(status === 'fresh'){
        return "yellow"
      }
      else if(status === 'started'){
        return "orange"
      }
      else if(status === 'completed'){
        return "green"
      }
      else{
        return "grey"
      }
    },

  },

  computed: {
    isLoggedIn() {
      return this.store.isLoggedIn;
    },

    firstName() {
      return this.store.user?.firstName || '';
    },

    lastName() {
      return this.store.user?.lastName || '';
    },  

    role() {
      return this.store.user?.role || 'guest';
    },  

    avatarUrl() {
      return this.store.user?.avatarUrl || '/images/logo.png';
    },

    metrics(){
      return [
        {
          title: this.$t('psychologistDashboard.active_clients'),
          value: `${this.noOfClients}`,
          icon: 'mdi-account-group',
          iconColor: 'blue',
          link: '/psychologist/clients'
        },
        {
          title: this.$t('psychologistDashboard.total_evaluations'),
          value: `${this.noOfEvaluations}`,
          icon: 'mdi-clipboard-list',
          iconColor: 'purple',
          link: '/psychologist/evaluations'
        }
      ];
    },

    lastEvaluations(){
      let evaluationWidgets = this.evaluations.map(evaluation=>{
        return {
          id: evaluation.evaluation_id,
          day: dayOfDate(evaluation.createdOn),
          dayName: dayNameOfDate(evaluation.createdOn),
          time: formatTime(evaluation.createdOn),
          title: `${evaluation.client.first_name} ${evaluation.client.last_name}`,
          scales: evaluation.scales.map(scale => {
            return scale.name;
          }),
          status: evaluation.status,
          evaluationToken: evaluation.token
        }
      });

      return evaluationWidgets;

      // return [
      //   {
      //     id: 1,
      //     day: '23',
      //     dayName: 'MON',
      //     time: '09:23 AM',
      //     title: 'John D.',
      //     avatars: [
      //       'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=face',
      //       'https://images.unsplash.com/photo-1494790108755-2616c27f9490?w=32&h=32&fit=crop&crop=face'
      //     ],
      //     count: '2+'
      //   },
      //   {
      //     id: 2,
      //     day: '24',
      //     dayName: 'TUE',
      //     time: '14:10 PM',
      //     title: 'Xela P.',
      //     avatars: [
      //       'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=32&h=32&fit=crop&crop=face',
      //       'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=32&h=32&fit=crop&crop=face',
      //       'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=32&h=32&fit=crop&crop=face'
      //     ],
      //     count: '5+'
      //   },
      //   {
      //     id: 3,
      //     day: '26',
      //     dayName: 'THU',
      //     time: '10:33 AM',
      //     title: 'Cristi D.',
      //     avatars: [
      //       'https://images.unsplash.com/photo-1554151228-14d9def656e4?w=32&h=32&fit=crop&crop=face',
      //       'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=32&h=32&fit=crop&crop=face'
      //     ],
      //     count: '2+'
      //   }
      // ]
    },


  }
}
</script>

<style scoped>
.border-b {
  border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.border-b:last-child {
  border-bottom: none;
}
</style>